module.exports = __webpack_public_path__ + "static/sec6-bg-065e8810ba35e1dfcdd401ff6f868944.jpg";